"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outlet = void 0;

var _mainNavigation = require("./mainNavigation");

var _orders = require("./orders");

var _products = require("./products");

var _shoppingCart = require("./shoppingCart");

var _suppliers = require("./suppliers");

var outlet = {
  MAIN_NAVIGATION: _mainNavigation.MAIN_NAVIGATION,
  ORDERS: _orders.ORDERS,
  PRODUCTS: _products.PRODUCTS,
  SHOPPING_CART: _shoppingCart.SHOPPING_CART,
  SUPPLIERS: _suppliers.SUPPLIERS
};
exports.outlet = outlet;